<script>
  import { Step } from 'element-ui'
  export default {
    name:'ElStep',
    extends:Step
  }
</script>
